// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"304":"7d848c1a","408":"933c5379","608":"de96dab7","617":"f29513ce","843":"4d64543e"}[chunkId] + ".chunk.js";
};